import { jsx as _jsx } from "react/jsx-runtime";
export const SourgumTenYdDimensions2 = (props) => {
    const src = new URL('./dumpster-10.png', import.meta.url).toString();
    return _jsx("img", { ...props, src: src, alt: "Ten Yard Dimensions" });
};
//# sourceMappingURL=ten-yard-dimensions-sourgum2.js.map